import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};

const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};

const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class GoogleDriveModuleAttributeFactory {
    /**
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.fileCreated(),
            this.fileUpdated()
        );
    }

    fileCreated() {
        const e = AutomationEventTypes.GOOGLE_DRIVE.FILE_CREATED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Google Drive Yeni Dosya", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.fileId`, "Dosya ID", vt.STRING),
                ga(context, `${prefix}.fileName`, "Dosya Adı", vt.STRING),
                ga(context, `${prefix}.mimeType`, "Dosya Tipi", vt.STRING),
                ga(context, `${prefix}.size`, "Dosya Boyutu (byte)", vt.NUMBER),
                ga(context, `${prefix}.createdTime`, "Oluşturulma Tarihi", vt.DATETIME),
                ga(context, `${prefix}.modifiedTime`, "Değiştirilme Tarihi", vt.DATETIME),
                ga(context, `${prefix}.webViewLink`, "Web Görüntüleme Linki", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal Bilgisi", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.channel._id`, "Kanal ID", vt.STRING),
                    ga(context, `${prefix}.channel.name`, "Kanal Adı", vt.STRING),
                    ga(context, `${prefix}.channel.type`, "Kanal Tipi", vt.STRING),
                ]),
                ga(context, `${prefix}.parents`, "Üst Klasörler", vt.ARRAY_STRING),
            ])
        ];
    }

    fileUpdated() {
        const e = AutomationEventTypes.GOOGLE_DRIVE.FILE_UPDATED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Google Drive Dosya Güncellendi", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.fileId`, "Dosya ID", vt.STRING),
                ga(context, `${prefix}.fileName`, "Dosya Adı", vt.STRING),
                ga(context, `${prefix}.mimeType`, "Dosya Tipi", vt.STRING),
                ga(context, `${prefix}.size`, "Dosya Boyutu (byte)", vt.NUMBER),
                ga(context, `${prefix}.createdTime`, "Oluşturulma Tarihi", vt.DATETIME),
                ga(context, `${prefix}.modifiedTime`, "Değiştirilme Tarihi", vt.DATETIME),
                ga(context, `${prefix}.webViewLink`, "Web Görüntüleme Linki", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal Bilgisi", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.channel._id`, "Kanal ID", vt.STRING),
                    ga(context, `${prefix}.channel.name`, "Kanal Adı", vt.STRING),
                    ga(context, `${prefix}.channel.type`, "Kanal Tipi", vt.STRING),
                ]),
                ga(context, `${prefix}.parents`, "Üst Klasörler", vt.ARRAY_STRING),
            ])
        ];
    }
}

export default GoogleDriveModuleAttributeFactory;
